/* eslint-disable */
import { Spin } from "antd";

export const Loader = ({spinning}) => {
  return (
    <div className={spinning || spinning === undefined ? "fullPageLoader" : ""}>
      <Spin spinning={spinning} />
    </div>
  )
}